// Registre de géocodage local pour le secteur frontalier (SCBI / Vanessa Tancredi)
export const CITY_COORDINATES = {
    "ottange": [49.446861, 6.020940],
    "dudelange": [49.4800, 6.0833],
    "fontoy": [49.3567, 5.9961],
    "volmerange-les-mines": [49.450104, 6.077676],
    "longwy": [49.527721, 5.777319],
    "mont-saint-martin": [49.533279, 5.779380],
    "herserange": [49.5181, 5.7844],
    "réhon": [49.5019, 5.7550],
    "lexy": [49.5011, 5.7317],
    "villers-la-montagne": [49.4719, 5.7208],
    "saulnes": [49.5317, 5.8239],
    "mercy-le-bas": [49.387402, 5.753300],
    "joppécourt": [49.3828, 5.7903],
    "boismont": [49.4128, 5.7367],
    "bazailles": [49.398495, 5.751959],
    "ville-au-montois": [49.411640, 5.779433],
    "fillières": [49.3697, 5.7303],
    "boudrezy": [49.3881, 5.6792],
    "longuyon": [49.4478, 5.6022],
    "pierrepont": [49.4161, 5.6964],
    "arrancy-sur-crusnes": [49.4128, 5.6567],
    "beuveille": [49.4328, 5.6881],
    "doncourt-lès-longuyon": [49.4386, 5.6372],
    "spincourt": [49.3308, 5.6644],
    "boulange": [49.382565, 5.950524],
    "aumetz": [49.427006, 5.932039],
    "audun-le-roman": [49.370293, 5.896579],
    "trieux": [49.3247, 5.9356],
    "hayange": [49.3297, 6.0622],
    "audun-le-tiche": [49.477375, 5.962997],
    "villerupt": [49.466591, 5.931563],
    "rumelange": [49.4589, 6.0294],
    "esch-sur-alzette": [49.4975, 5.9819],
    "hettange-grande": [49.404385, 6.153591],
    "thionville": [49.371979, 6.172246],
    "yutz": [49.353977, 6.209179],
    "cattenom": [49.4064, 6.2433],
    "roussy-le-village": [49.4561, 6.1739],
    "kanfen": [49.440281, 6.105414],
    "zoufftgen": [49.4631, 6.1347],
    "tressange": [49.413280, 5.989596],
    "havange": [49.389263, 5.990114],
    "russange": [49.479256, 5.953104],
    "rédange": [49.4978, 5.9189],
    "hussigny-godbrange": [49.499031, 5.863207],
    "tiercelet": [49.4628, 5.8825],
    "errouville": [49.417500, 5.897800],
    "crusnes": [49.430046, 5.935319],
    "serrouville": [49.4006, 5.8897],
    "brehain-la-ville": [49.4400, 5.8856],
    "differdange": [49.5219, 5.8886],
    "kayl": [49.4878, 6.0392],
    "schifflange": [49.5086, 6.0125],
    "bettembourg": [49.5186, 6.1017],
    "fentange": [49.5667, 6.1500],
    "piennes": [49.305061, 5.791520],
    "nilvange": [49.344635, 6.040472],
    "algrange": [49.3589, 6.0494],
    "knutange": [49.3378, 6.0397],
    "florange": [49.323978, 6.135957],
    "fameck": [49.3014, 6.1089],
    "uckange": [49.3028, 6.1558],
    "serémange-erzange": [49.3206, 6.0906],
    "neufchef": [49.3175, 6.0247],
    "briey": [49.2486, 5.9381],
    "tucquegnieux": [49.3047, 5.8939],
    "bouligny": [49.306095, 5.767029],
    "joudreville": [49.2969, 5.7725],
    "coin-lès-cuvry": [49.024601, 6.141200],
    "coin-lës-cuvry": [49.024601, 6.141200],
    "coin-les-cuvry": [49.024601, 6.141200],
    "mondelange": [49.258606, 6.168145],
    "thil": [49.469879, 5.906213],
    "xivry-circourt": [49.357204, 5.760051],
    "brouennes": [49.5313, 5.2536],
    "landres": [49.321346, 5.811100],
    "norroy-le-sec": [49.278278, 5.808450],
    "mont-bonvillers": [49.329910, 5.834330],
    "ogy-montoy-flanville": [49.117935, 6.286685],
    "saint-supplet": [49.381905, 5.736139],
    "vilosnes-haraumont": [49.329571, 5.232631],
    "haucourt-moulaine": [49.508850, 5.807398],
    "haucourt moulaine": [49.508850, 5.807398],
    "mancieulles": [49.277748, 5.890629],
    "morfontaine": [49.444832, 5.811680],
    "jarny": [49.163021, 5.871180],
    "cutry": [49.479019, 5.740610],
    "tétange": [49.4744, 6.0417],
    "tetange": [49.4744, 6.0417],
    "montfaucon-d'argonne": [49.267689, 5.140116],
    "escherange": [49.415413, 6.069646],
    "hussigny godbrange": [49.499031, 5.863207]
};

// Siège social d'Ottange par défaut
export const DEFAULT_CENTER = [49.4443, 6.0195];

/**
 * Résout les coordonnées géographiques d'un bien au niveau de sa VILLE uniquement.
 * Pour des raisons de confidentialité et de discrétion, nous n'affichons jamais
 * la localisation exacte (adresse) des biens sur la carte publique.
 */
export function getPropertyCoordinates(property) {
    if (!property) return DEFAULT_CENTER;

    // Utiliser en priorité les coordonnées de la base de données si elles existent et sont valides
    let lat = 0;
    let lng = 0;
    let hasCoords = false;

    if (typeof property.latitude === 'number' && typeof property.longitude === 'number' && property.latitude !== 0 && property.longitude !== 0) {
        lat = property.latitude;
        lng = property.longitude;
        hasCoords = true;
    } else if (property.latitude && property.longitude) {
        const parsedLat = parseFloat(property.latitude);
        const parsedLng = parseFloat(property.longitude);
        if (!isNaN(parsedLat) && !isNaN(parsedLng) && parsedLat !== 0 && parsedLng !== 0) {
            lat = parsedLat;
            lng = parsedLng;
            hasCoords = true;
        }
    }

    if (hasCoords) {
        // Pour garantir la confidentialité et empêcher de retrouver l'adresse exacte du vendeur,
        // nous appliquons un léger décalage déterministe (le marqueur reste stable au même endroit)
        // d'environ 300 à 500 mètres dans une direction aléatoire.
        const idStr = String(property.id || property.netty_ref || "");
        let hash = 0;
        for (let i = 0; i < idStr.length; i++) {
            hash = idStr.charCodeAt(i) + ((hash << 5) - hash);
        }
        // Décalage pseudo-aléatoire entre -0.004 et +0.004 degrés (environ 300 à 450 mètres)
        const latOffset = ((hash % 100) / 100) * 0.008 - 0.004;
        const lngOffset = (((hash >> 8) % 100) / 100) * 0.008 - 0.004;
        return [lat + latOffset, lng + lngOffset];
    }

    const city = (property.city || "").toLowerCase().trim();
    if (!city) return DEFAULT_CENTER;

    // Correspondance exacte
    if (CITY_COORDINATES[city]) {
        return CITY_COORDINATES[city];
    }

    // Correspondance avec tirets à la place d'espaces
    const cityHyphenated = city.replace(/\s+/g, '-');
    if (CITY_COORDINATES[cityHyphenated]) {
        return CITY_COORDINATES[cityHyphenated];
    }

    // Retirer les déterminants comme "les", "sur", etc. pour correspondances floues
    const cleanCity = city.replace(/-(les-mines|sur-crusnes|les|sur|sous)/g, '');
    if (CITY_COORDINATES[cleanCity]) {
        return CITY_COORDINATES[cleanCity];
    }

    // Recherche partielle
    for (const key in CITY_COORDINATES) {
        if (city.includes(key) || key.includes(city)) {
            return CITY_COORDINATES[key];
        }
    }

    return DEFAULT_CENTER;
}
